module.exports = __webpack_public_path__ + "static/media/CabinSketch.6a572491.woff";